import type { SearchExpert } from '@bulknutrients/bulk-shared-lib/interfaces/Expert';

import { SearchResultCardExpert } from '../SearchResultCardExpert';

export function ExpertsList({ data }: { data: SearchExpert[] }) {
  return (
    <div className="ga-search-list ga-search-experts grid grid-cols-1 gap-10 pb-8 md:grid-cols-2 xl:grid-cols-3">
      {data.map((d) => (
        <SearchResultCardExpert hit={d} key={d.name} />
      ))}
    </div>
  );
}
